function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 205.5c9.8 0 17.7 7.9 17.7 17.7s-7.9 17.7-17.7 17.7S124 233 124 223.2s7.9-17.7 17.7-17.7zM205.5 0H78C62.3 0 49.6 12.7 49.6 28.3v226.8c0 15.7 12.7 28.4 28.4 28.4h127.5c15.7 0 28.3-12.7 28.4-28.4V28.3C233.8 12.7 221.2 0 205.5 0zm0 255.1H78V28.3h127.5v226.8zm-85-212.6H163v14.2h-42.5V42.5z"
})));